import React from 'react'
import { Outlet } from 'react-router-dom'
import ThemeSettings from '../InitialPage/themeSettings'

const PosLayout = () => {
  return (
    <>
        <Outlet />
        <ThemeSettings />
    </>
  )
}

export default PosLayout